// extracted by mini-css-extract-plugin
export default {"newsList":"styles_newsList__KSJTT"};